/**
 * Telephone Link Classes
 * Adds ga-telephone-{state-name} class to tel: links based on area code.
 */
(function () {
    'use strict';

    var areaCodeMap = {
        '605': 'south-dakota',
        '712': 'iowa',
        '515': 'iowa',
        '405': 'oklahoma',
        '952': 'minnesota',
        '701': 'north-dakota',
        '402': 'nebraska'
    };

    function addTelephoneClasses() {
        document.querySelectorAll('a[href^="tel:"]').forEach(function (el) {
            var digits = el.getAttribute('href').replace('tel:', '').replace(/\D/g, '');
            var areaCode = digits.slice(0, 3);
            var stateName = areaCodeMap[areaCode];
            if (stateName) el.classList.add('ga-telephone-' + stateName);
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', addTelephoneClasses);
    } else {
        addTelephoneClasses();
    }
})();
